import axios from "axios";

axios.defaults.withCredentials = true;

let inFlightVerify = null;
let lastResponse = null;
let lastResponseTs = 0;

export function verifyLogin() {
  // If a verify request is already in-flight, return the same promise
  if (inFlightVerify) return inFlightVerify;

  const now = Date.now();
  // If we have a very recent response, reuse it to avoid duplicate quick calls
  if (lastResponse && now - lastResponseTs < 500) {
    return Promise.resolve(lastResponse);
  }

  inFlightVerify = axios
    .get("/backend/login_verification", { withCredentials: true })
    .then((res) => {
      lastResponse = res;
      lastResponseTs = Date.now();
      return res;
    })
    .finally(() => {
      inFlightVerify = null;
    });

  return inFlightVerify;
}



export function clearVerifyCache() {
  // Notify listeners so they can re-check auth status.
  lastResponse = null;
  lastResponseTs = 0;
  try {
    window.dispatchEvent(new Event("authChanged"));
  } catch (e) {
    // ignore in non-browser environments
  }
}
